import React from "react";
import { useSelector } from "react-redux";
import {
  deleteSessionPreference,
  getSessionPreferences,
} from "../../../redux/features/croSlice";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";

const DeleteSessionPreference = ({ id, data }) => {
  const { loading } = useSelector((state) => state.cro);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Preference"}
      deleteNote={"Are you sure? you want to delete this Session..?"}
      api={deleteSessionPreference([id])}
      upDateCall={getSessionPreferences(data)}
      loading={loading}
    />
  );
};

export default DeleteSessionPreference;
